import { uniReactRoot } from '@affine/component';
import type { SyntheticEvent } from 'react';

import {
  TableSelector,
  type TableSelectorProps,
} from '../../../../modules/streamlain/sidebar/components/table-selector';

const stopCanvasEvent = (event: SyntheticEvent) => event.stopPropagation();

/** React portals retain their editor ancestry; keep picker events in the overlay. */
function RelationDatabaseSelector(props: TableSelectorProps) {
  return (
    <div
      onPointerDown={stopCanvasEvent}
      onMouseDown={stopCanvasEvent}
      onClick={stopCanvasEvent}
      onKeyDown={stopCanvasEvent}
    >
      <TableSelector {...props} />
    </div>
  );
}

/** Automations and relation configuration share one workspace table picker. */
export const relationDatabaseSelector = uniReactRoot.createUniComponent(
  RelationDatabaseSelector
);
